module.exports = __webpack_public_path__ + "img/jiazhang.402a7f3e.png";